<header class="web-nav">
  <nav class="nav-wrapper" aria-label="Main">
    <div class="left">
      <a routerLink="/" aria-label="Avaana home" (click)="closeMenus()">
        <img src="assets/images/website/avaana-logo.svg" alt="Avaana" width="99" height="26" />
      </a>
      <ul class="main-menu">
        <li class="dropdown">
          <button
            type="button"
            class="nav-link"
            (click)="toggleHowItWorks($event)"
            [attr.aria-expanded]="showHowItWorks"
            aria-haspopup="true">
            How it works
            <img
              src="assets/images/website/chevron-down.svg"
              alt=""
              width="10"
              height="5"
              [class.open]="showHowItWorks" />
          </button>
          @if (showHowItWorks) {
          <ul class="popover links">
            @for (item of howItWorksLinks; track item) {
            <li>
              <a [routerLink]="item.link" (click)="closeMenus()">{{ item.label }}</a>
            </li>
            }
          </ul>
          }
        </li>
        @for (item of mainLinks; track item) {
        <li>
          <a class="nav-link" [routerLink]="item.link">{{ item.label }}</a>
        </li>
        }
      </ul>
    </div>
    <div class="utility">
      <a class="nav-link" routerLink="/for-providers">For providers</a>
      <div class="login-dropdown-wrap">
        <button
          type="button"
          class="nav-link"
          (click)="toggleLoginDropdown($event)"
          [attr.aria-expanded]="showLoginDropdown()"
          aria-haspopup="true">
          @if (isUserLoggedIn()) {
          <span class="logged-user">
            {{ loggedUser().first_name }}
            @if (loggedUser().correct_image) {
            <img [src]="loggedUser().correct_image" alt="" />
            } @if (!loggedUser().correct_image) {
            <span class="no-image">{{ loggedUser().first_name?.[0] }}{{ loggedUser().last_name?.[0] }}</span>
            }
          </span>
          } @else { Provider log in }
        </button>
        @if (showLoginDropdown()) {
        <div
          class="dropdown-popover login-popover"
          role="form"
          aria-label="Login form"
          (click)="keepDropdownOpen($event)">
          <span class="popover-tip" aria-hidden="true"></span>
          <ng-container *ngTemplateOutlet="loginPanel"></ng-container>
        </div>
        }
      </div>
      <button class="demo-btn" type="button" (click)="bookDemo()">Book a demo</button>
    </div>
    <button
      class="menu-btn"
      type="button"
      aria-label="Menu"
      [attr.aria-expanded]="showMobileMenu"
      (click)="toggleMobileMenu()">
      <img src="assets/images/website/menu.svg" alt="" width="24" height="24" />
    </button>
  </nav>

  @if (showMobileMenu) {
  <div class="mobile-menu">
    <p class="group-title">How it works</p>
    @for (item of howItWorksLinks; track item) {
    <a [routerLink]="item.link" (click)="closeMenus()">{{ item.label }}</a>
    }
    <span class="separator"></span>
    @for (item of mainLinks; track item) {
    <a [routerLink]="item.link" (click)="closeMenus()">{{ item.label }}</a>
    }
    <a routerLink="/for-providers" (click)="closeMenus()">For providers</a>
    <span class="separator"></span>
    <p class="group-title">{{ isUserLoggedIn() ? loggedUser().first_name : 'Provider log in' }}</p>
    <div class="mobile-login login-dropdown-wrap login-popover" (click)="keepDropdownOpen($event)">
      <ng-container *ngTemplateOutlet="loginPanel"></ng-container>
    </div>
    <button class="demo-btn" type="button" (click)="bookDemo()">Book a demo</button>
  </div>
  }
</header>

<!-- Same log in flow and markup as the V2 header (logic inherited from HomeHeaderNewComponent) -->
<ng-template #loginPanel>
  @if (!isUserLoggedIn()) {
  <form [formGroup]="signInForm" (ngSubmit)="signInUser()">
    <input
      type="email"
      class="login-input"
      placeholder="Enter your email"
      aria-label="email"
      formControlName="email"
      autocomplete="email" />
    <input
      type="password"
      class="login-input"
      placeholder="Enter your password"
      aria-label="Password"
      formControlName="password"
      autocomplete="current-password" />
    <a [routerLink]="['/forgot-password']" class="forgot-password-link" (click)="closeMenus()">Forgot Password?</a>
    <div class="login-actions">
      <button type="submit" class="submit-btn">
        @if (loading()) {
          <i class="fa-solid fa-spin fa-spinner"></i>
        }
        Login
      </button>
    </div>
  </form>
  } @if (!isUserLoggedIn()) {
  <div class="sign-up-option">
    New to Avaana? <a (click)="closeMenus()" [routerLink]="['/business/provider/signup']">Sign up</a>
  </div>
  } @if (isUserLoggedIn()) {
  <ul class="profile">
    <li>
      <a [routerLink]="['/profile']" (click)="closeMenus()">
        <div class="menu">
          <span class="arrow-btn"><img loading="lazy" src="assets/images/menu/person-outline.svg" alt="" /></span>
          <p class="name">My Profile</p>
        </div>
        <span class="arrow-btn no-bg"
          ><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"
        /></span>
      </a>
    </li>
    @if (hasBusiness()) {
    <li>
      <a [routerLink]="fetchBusinessRouting()" (click)="closeMenus()">
        <div class="menu">
          <span class="arrow-btn"><img loading="lazy" src="assets/images/menu/dashboard.svg" alt="" /></span>
          <p class="name">Business Dashboard</p>
        </div>
        <span class="arrow-btn no-bg"
          ><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"
        /></span>
      </a>
    </li>
    } @if (isWellbeingOwner()) {
    <li>
      <a (click)="closeMenus()" [href]="getWellbeingLocation()" target="_blank" rel="noopener">
        <div class="menu">
          <span class="arrow-btn"><img loading="lazy" src="assets/images/menu/dashboard.svg" alt="" /></span>
          <p class="name">Wellbeing Dashboard</p>
        </div>
        <span class="arrow-btn no-bg"
          ><img loading="lazy" src="assets/images/booking/right-arrow.svg" alt="right arrow"
        /></span>
      </a>
    </li>
    }
  </ul>
  } @if (isUserLoggedIn()) {
  <ul class="logout-holder">
    <li>
      <a (click)="logoutUser()">Logout <i class="fa fa-arrow-right-from-bracket"></i></a>
    </li>
  </ul>
  }
</ng-template>
